export default __webpack_public_path__ + "static/media/user-icon.62b85bd1.svg";